import React__default from 'react';
import { dayjs } from '@keepeek/commons';
import { Typography } from '@mui/material';
import isArray from 'lodash/isArray';

var ElementDuration = function (_a) {
    var value = _a.value, className = _a.className;
    var duration = Number(isArray(value) ? value[0] : value);
    var formatDuration = dayjs.duration(duration, "seconds").format("H:mm:ss");
    return (React__default.createElement(Typography, { variant: "caption", sx: {
            color: function (theme) { return theme.palette.common.white; },
            backgroundColor: function (theme) { return theme.palette.common.black; },
            font: "14px 'Open Sans',Tahoma,Arial,Verdana,sans-serif",
            padding: function (theme) { return theme.spacing(0.3); }
        }, title: formatDuration, className: className }, formatDuration));
};

export { ElementDuration as default };
//# sourceMappingURL=index.js.map
